import { Component } from 'react'
import companyImg from '../../../../../../assets/images/company.png'
import './styles.sass'
import { RouterProps, withRouter } from '../../../../../../insfrastructure/utils/with-router-component';

class CompanyFormConfirmationRequest extends Component<RouterProps> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const pendingApproval = !!this.props.location.state?.pendingApproval;
    const email = this.props.location.state?.email || 'seu e-mail';

    // Cadastro de recrutador em empresa existente: passa por aprovação.
    // Página dedicada — a aprovação é o assunto principal, não um aviso lateral.
    if (pendingApproval) {
      return (
        <div className='company-sign-up-form-confirmation-request'>
          <div className='content'>
            <div className='block pending'>
              <div>
                <h3>Quase lá!</h3>
                <p>
                  Seu cadastro de recrutador foi recebido e está em análise
                  pela equipe Emprega Mecânico.
                </p>
              </div>
              <img src={companyImg} alt='' />
              <div className='steps-block'>
                <p className='steps-title'>Falta pouco:</p>
                <ol className='steps'>
                  <li>Confirme seu e-mail (enviamos para <b>{email}</b>).</li>
                  <li>Aguarde o e-mail com o resultado da aprovação.</li>
                </ol>
              </div>
              <button
                type='button'
                className='login-btn'
                onClick={() => this.props.navigate('/login')}
              >
                Voltar para o login
              </button>
            </div>
          </div>
        </div>
      );
    }

    // Empresa nova (ou demais fluxos): confirmação genérica, sem aprovação.
    return (
      <div className='company-sign-up-form-confirmation-request'>
          <div className='content'>
            <div className='block'>
              <div>
                <h3>Parabéns!</h3>
                <p>Agora você faz parte da maior rede mecânicos do Brasil</p>
              </div>
              <img src={companyImg} />
              <div>
                <p>Enviamos um e-mail para {email}.</p>
                <p>Por favor, confirme e prossiga com a ativação da sua conta.</p>
              </div>
            </div>
          </div>
      </div>
    )
  }
}

export default withRouter(CompanyFormConfirmationRequest);
